import { API } from "@project/shared"

export const createMyPageSettings = async (values: any) => {
  return API.post(`mypage-setting`, values)
}

export const fetchMyPageSetting = async (): Promise<{ data }> => {
  return API.get(`mypage-setting`)
}
